import React from "react";
import { Box, Grid, Tab } from "@mui/material";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import CommonAutoComplete from "components/commonAutoComplete/CommonAutoComplete";
import CommonOutStation from "components/commonAutoComplete/CommonOutStation";
import { tripEnumObject } from "utils/enumObject";

function CommonRideTab(props) {
  return (
    <Grid container justifyContent="space-between" alignItems="center" item xs={12}>
      <Grid item className="tableContainer" xs={12}>
        <Box
          // bgLiteColor will come only for after login
          className={!props?.token ? "contentBoxStyle" : null}
        >
          <TabContext value={props.value}>
            <Grid
              container
              className="tabBoxStyle width100"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item className="width100">
                <TabList
                  className="minHeight32 tabBG width100"
                  onChange={props.handleTabChange}
                  aria-label="lab API tabs example"
                  xs={6}
                  TabIndicatorProps={{
                    style: { display: "none" },
                  }}
                >
                  <Tab label="Oneway" value={tripEnumObject?.oneWay} className="tabStyle" />
                  <Tab label="Rental" value={tripEnumObject?.rental} className="tabStyle" />
                  <Tab
                    label="Airport Transfer"
                    value={tripEnumObject?.airport}
                    className="tabStyle"
                  />
                  <Tab
                    label="Outstation"
                    value={tripEnumObject?.outStationRound}
                    className="tabStyle"
                  />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value={tripEnumObject?.oneWay} className="tabPanelStyle">
              <Grid item className={props?.btnEnable === false ? "ridep0" :"rideCard"}>
                <CommonAutoComplete
                  formData={props?.formData}
                  location={[]}
                  onInputChangeVal={props?.onInputChangeVal}
                  locationData={props?.locationData}
                  currentLocationData={props?.currentLocationData}
                  onCurrentAddress={props?.onCurrentAddress}
                  currentLat={props?.currentLat}
                  currentLong={props?.currentLong}
                  defaultTripValues={props?.defaultTripValues}
                  btnEnable={props?.btnEnable}
                  token={props?.token}
                  onSubmitBtn={props?.onSubmitBtn}
                  onHandleChange={props?.onHandleChange}
                  onChangeDate={props?.onChangeDate}
                  currentLoader={props?.currentLoader}
                  type = {tripEnumObject?.oneWay}
                  handleInput={props?.handleInput}
                  timeSlabData={props?.timeSlabData}
                  nearbySearchData={props?.nearbySearchData}
                  bufferTime={props?.bufferTime}
                  pageType={props?.pageType}
                />
              </Grid>
            </TabPanel>
            <TabPanel value={tripEnumObject?.rental} className="tabPanelStyle">
              <Grid item className={props?.btnEnable === false ? "ridep0" :"rideCard"}>
                <CommonAutoComplete
                  formData={props?.formData}
                  optionData={props?.optionData}
                  location={[]}
                  onInputChangeVal={props?.onInputChangeVal}
                  locationData={props?.locationData}
                  currentLocationData={props?.currentLocationData}
                  onCurrentAddress={props?.onCurrentAddress}
                  currentLat={props?.currentLat}
                  currentLong={props?.currentLong}
                  defaultTripValues={props?.defaultTripValues}
                  btnEnable={props?.btnEnable}
                  token={props?.token}
                  onSubmitBtn={props?.onSubmitBtn}
                  onHandleChange={props?.onHandleChange}
                  onChangeDate={props?.onChangeDate}
                  currentLoader={props?.currentLoader}
                  handleInput={props?.handleInput}
                  type = {tripEnumObject?.rental}
                  rentalPackage={props?.rentalPackage}
                  timeSlabData={props?.timeSlabData}
                  bufferTime={props?.bufferTime}
                  pageType={props?.pageType}
                />
              </Grid>
            </TabPanel>
            <TabPanel value={tripEnumObject?.airport} className="tabPanelStyle">
              <Grid item className={props?.btnEnable === false ? "ridep0" :"rideCard"}>
                <CommonAutoComplete
                  formData={props?.formData}
                  optionData={props?.optionData}
                  location={[]}
                  onInputChangeVal={props?.onInputChangeVal}
                  locationData={props?.locationData}
                  currentLocationData={props?.currentLocationData}
                  onCurrentAddress={props?.onCurrentAddress}
                  currentLat={props?.currentLat}
                  currentLong={props?.currentLong}
                  defaultTripValues={props?.defaultTripValues}
                  btnEnable={props?.btnEnable}
                  token={props?.token}
                  onSubmitBtn={props?.onSubmitBtn}
                  onHandleChange={props?.onHandleChange}
                  onChangeDate={props?.onChangeDate}
                  currentLoader={props?.currentLoader}
                  handleInput={props?.handleInput}
                  type = {tripEnumObject?.airport}
                  airportOptionData={props?.airportOptionData}
                  timeSlabData={props?.timeSlabData}
                  bufferTime={props?.bufferTime}
                  pageType={props?.pageType}
                />
              </Grid>
            </TabPanel>
            <TabPanel value={tripEnumObject?.outStationRound} className={`tabPanelStyle ${!props?.noscroll && 'outStationTab'}`}>
              <Grid item className={props?.btnEnable === false ? "ridep0" :"rideCard"}>
                <CommonAutoComplete
                  formData={props?.formData}
                  location={[]}
                  onInputChangeVal={props?.onInputChangeVal}
                  locationData={props?.locationData}
                  currentLocationData={props?.currentLocationData}
                  onCurrentAddress={props?.onCurrentAddress}
                  currentLat={props?.currentLat}
                  currentLong={props?.currentLong}
                  defaultTripValues={props?.defaultTripValues}
                  btnEnable={props?.btnEnable}
                  token={props?.token}
                  onSubmitBtn={props?.onSubmitBtn}
                  onHandleChange={props?.onHandleChange}
                  onChangeDate={props?.onChangeDate}
                  currentLoader={props?.currentLoader}
                  type = {tripEnumObject?.outStationRound}
                  handleInput={props?.handleInput}
                  timeSlabData={props?.timeSlabData}
                  bufferTime={props?.bufferTime}
                  pageType={props?.pageType}
                />
              </Grid>
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default CommonRideTab;
